<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_first_four"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,       //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
                    [
                        {offset: 0, color: '#00F6FF'},
                        {offset: 1, color: '#0290FE'}
                    ]                //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
                ),
                title: {
                    text: "社会消费品零售额",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: "center",
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid,
                xAxis: {
                    name: "年",
                    type: "category",
                    data: [],
                    ...axis,
                },
                yAxis: {
                    name: "万",
                    ...axis,
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=24`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.yAxis.name = data[0].dataArr[0].units
                let x = data[0].dataArr.map((item) => item.name);
                // option.legend.data = x;//单个柱子不需要图例
                option.series = x.map((item) => {
                    return {
                        name: item,
                        data: [],
                        type: "bar",
                        barWidth: '14px',
                        itemStyle: {
                            barBorderRadius: 4,
                        },
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.xAxis.data.push(item.time);
                    option.xAxis.data = option.xAxis.data.slice(-5)
                    let obj = {};
                    item.dataArr.forEach((itemx) => {
                        obj[itemx.name] = itemx.value;
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                        //显示后5年的
                        item.data = item.data.slice(-5)
                    });
                });

                var myChart = echarts.init(
                    document.getElementById("echart_first_four")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_first_four {
    height:250px
}
</style>
